import React from 'react';
import { Input, Icon } from 'antd';
import cn from 'classnames';
import styles from './TextAreaField.module.scss';
import FormItem from '../FormItem/FormItem';

const { TextArea } = Input;

const TextAreaField = ({
  label,
  form,
  name,
  options,
  className,
  inline = false,
  colon = false,
  inputProps,
  onRemoveField,
  ...props
}) => {
  return (
    <FormItem
      {...props}
      inline={inline}
      colon={colon}
      label={label}
      className={className}
    >
      {form.getFieldDecorator(name, options)(<TextArea {...inputProps} />)}
    </FormItem>
  );
};

export default TextAreaField;
